// The email rides in router state because the page URL reaches the ad and analytics pixels.
export function authLocation(pathname: string, search: string, email?: string) {
  const params = new URLSearchParams(search);
  params.delete('email');
  const query = params.toString();

  return { pathname, search: query ? `?${query}` : '', state: email ? { email } : undefined };
}

// Only a dashboard page is a place to return to: a 401 on the login page itself must not loop back to it.
export function loginUrl(pathname: string, search: string) {
  const params = new URLSearchParams(search);
  if (/^\/dashboard(\/|$)/.test(pathname)) params.set('redirect', pathname);
  const query = params.toString();

  return query ? `/login?${query}` : '/login';
}

// A flow that sends people to log in (an MCP connection, a template) keeps its own
// params next to `redirect`. Invite params travel in the OAuth state and stay out of the URL.
export function authRedirectPath(search: string) {
  const params = new URLSearchParams(search);
  const redirectPath = params.get('redirect') || '/dashboard';
  ['redirect', 'email', 'invite', 'inviteToken', 'team'].forEach(key => params.delete(key));
  const query = params.toString();

  return query ? `${redirectPath}?${query}` : redirectPath;
}

// A new account made to connect Claude or ChatGPT carries the consent screen through
// onboarding, or the connection request is lost.
export function newAccountPath(returnPath: string, onboardingPath: string) {
  if (!returnPath.startsWith('/oauth/authorize?')) return onboardingPath;

  const [pathname, query = ''] = onboardingPath.split('?');
  const params = new URLSearchParams(query);
  params.set('next', returnPath);
  return `${pathname}?${params.toString()}`;
}
